<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    addWhat: {
      type: Object,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
    },
    itemClass: {
      type: String,
      default: 'item-class',
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    comboValue: {},
    itemFunction: {
      type: Function,
    },
    invoiceProduct: {
      type: Boolean,
      default: false,
    },
    disabled: {
      default: true,
    },
  },
  mounted() {
    if (this.pagination) {
      let callback = entries => {
        if (entries[0].isIntersecting) {
          this.$emit('loadMoreData')
        }
      }
      const observer = new IntersectionObserver(callback)
      observer.observe(this.$refs.infinity)
    }
  },
  data() {
    return {
      newVal: '',
      searchedValue: '',
      isToggled: false,
    }
  },
  computed: {
    changeHandler() {
      return this.$emit('input', this.newVal)
    },
  },
  methods: {
    openModal(obj) {
      if (obj.type === 'detail') {
        this.$emit('showModal', obj.type)
      } else if (obj.type === 'customer') {
        this.$emit('showModal', obj.type)
      } else if (obj.type === 'company') {
        this.$emit('showModal', obj.type)
      } else if (obj.type === 'agent') {
        this.$emit('showModal', obj.type)
      }
    },
    startSearch() {
      const searchInput = this.$refs.input
      if (searchInput.value.length >= 2) {
        const time = setTimeout(() => {
          this.$emit('search', this.searchedValue)
          clearTimeout(time)
        }, 1500)
      }
    },
  },
}
</script>

<template>
  <div class="mainInput" :class="classes">
    <span v-if="showTitle" class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</span>
    <div class="combobox-wrapper w-100">
      <b-dropdown variant="link" no-caret menu-class="w-100 p-0 " :disabled="disable" @show="isToggled = true" @hide="isToggled = false">
        <template #button-content>
          <div class="position-relative">
            <input class="input-like w-100" :placeholder="placeholder" v-model="comboValue" :disabled="disabled" />
            <div class="position-absolute arrows">
              <i :class="{ down: isToggled, up: !isToggled }" style="color:#74788D"></i>
            </div>
          </div>
        </template>
        <div class="p-2">
          <div class="search-wrapper justify-content-between d-flex align-items-center w-100">
            <div class="search-input-wrapper position-relative w-100">
              <input autocomplete="off" ref="input" placeholder="جستجو" type="search" id="search" @keyup="startSearch()" v-model="searchedValue" />
            </div>
          </div>
          <div class="scroll" v-if="items.length > 0">
            <b-dropdown-item v-for="item in items" :key="invoiceProduct ? item.key : item.value" class="custom-items py-1" @click="itemFunction(item)">
              <div class="d-flex align-items-center justify-content-between" :class="itemClass">{{ invoiceProduct ? item.name : item.value }}</div>
            </b-dropdown-item>
            <div v-if="pagination" ref="infinity" class="infinity-pagination"></div>
          </div>
          <div class="mt-2" v-else>دیتایی موجود نمی باشد.</div>
        </div>

        <b-dropdown-item class="add-customer" style="border-top: 1px solid #ced4da" @click="openModal(addWhat)">
          <p class="p-2 m-0 p">{{ addWhat.text }}</p>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.input-like {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  border-radius: 4px;
  box-sizing: border-box;
  height: 32px;
  cursor: pointer;
}

::v-deep button.dropdown-toggle {
  padding: 0 !important;
}
::v-deep div.b-dropdown {
  width: 100%;
}
.search-input-wrapper input {
  border-radius: 4px;
}

.mainInput {
  display: flex;
  align-items: center;
}
input {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
i {
  position: absolute;
  top: 50%;
  left: 0;
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
.labelStyle {
  min-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
:v-deep .custom-items {
  transition: 0.2s ease-in-out;
}
:v-deep .custom-items:hover {
  background-color: #f2f4f7;
}
:v-deep .add-customer {
  border-top: 1px solid #ced4da;
  cursor: pointer;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  transition: 0.2s ease-in-out;
}
:v-deep .add-customer:hover {
  background-color: #f2f4f7;
}

::v-deep a.dropdown-item {
  padding: 0 !important;
}
.p {
  color: #556ee6 !important;
}
::v-deep button.dropdown-toggle {
  padding: 0 !important;
  height: 100%;
  outline: none !important;
  box-shadow: none !important;
}

.arrows {
  left: 8px;
  top: 34%;
  color: rgb(36, 23, 23);
  font-size: 11px;
}
.scroll {
  padding-bottom: 3px;
  position: relative;
  overflow-y: scroll;
  max-height: 270px;
}
.infinity-pagination {
  position: absolute;
  bottom: -2px;
}
.scroll::-webkit-scrollbar {
  display: none;
}
</style>
